import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

import { Site } from '../../core/modules/sites/Site';
import { BattleTest } from '../../core/types/Battle';
import { EventBattle } from '../../types/Battle';
import { getDeviceCategory } from '../../utils/getDeviceCategory';
import getUrlParameters from '../../utils/getUrlParameters';

import { getDataHash } from './getDataHash';

dayjs.extend(weekOfYear);

export type HashParams = {
  articleType?: string;
  articleCategory?: string;
  site: Site;
  area?: string;
  merchantName: string | null;
  battle?: BattleTest | EventBattle | null;
};

export const getCustomTrackingId = async (params: HashParams): Promise<string> => {
  // Allow forcing the ID for Cypress tests
  const { customTrackingId } = getUrlParameters();
  if (customTrackingId) {
    return Promise.resolve(customTrackingId);
  }

  const useLessGranularTracking = params.merchantName?.startsWith('Amazon');

  if (useLessGranularTracking) {
    return getDataHash({
      articleType: params.articleType,
      articleCategory: params.articleCategory,
      utm_medium: getUrlParameters(['utm_medium']).utm_medium,
      site: params.site,
      area: params.area,
      battle: params.battle,
      weekNumber: dayjs().week(),
      deviceCategory: getDeviceCategory(),
    });
  }

  return getDataHash({ randomNumber: Math.random() });
};
